import { lazy } from 'react';


export const MapSite = lazy(() => import('./MapSite'));
